export default __webpack_public_path__ + "static/media/kitchen5-beforeD-480w.e518a3e8.avif";